import styled, { css as styledCSS } from "styled-components";

export interface WizardStepProps {
  status: "active" | "completed" | "default";
  hasLabel: boolean;
}

export const WizardStep = styled.div<WizardStepProps>`
  display: flex;
  align-items: center;
  margin: 0 4px;

  label {
    color: var(--mode-text-neutral-weakest-disabled);
  }

  ${({ hasLabel, status }) =>
    hasLabel &&
    status === "completed" &&
    styledCSS`${StepNumber}:hover, label:hover {
      cursor: pointer;        
    }`}

  ${({ hasLabel }) => hasLabel && styledCSS`${StepNumber} {margin-right: 4px;}`}
  ${({ status }) =>
    status === "completed" &&
    styledCSS`&:hover ${StepNumber} {
    background-color: var(--mode-text-neutral-weakest);                
  }
    &:hover label {
      color: var(--mode-text-neutral-weakest);
    }`}


  ${({ status }) => {
    switch (status) {
      case "active":
        return styledCSS`
            ${StepNumber} {
              color: var(--mode-text-neutral-inverse);
              background-color: var(--mode-text-neutral-default-weak);
            }
            label {
              color: var(--mode-text-neutral-default-weak);
            }`;
      case "completed":
        return styledCSS`
        ${StepNumber} {
              color: var(--mode-text-neutral-inverse);
              background-color: var(--mode-text-neutral-weakest-disabled);
            }
            label {
              color: var(--mode-text-neutral-weakest-disabled);
            }`;

      default:
        return styledCSS`
        ${StepNumber} {
              color: var(--mode-text-neutral-weakest-disabled);
              border: 0.5px solid ;
              border-color: var(--mode-text-neutral-weakest-disabled);
            `;
    }
  }}
`;
export const StepNumber = styled.div`
  width: 19px;
  height: 19px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  line-height: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
